export default "__VITE_ASSET__DvvCaFCj__"